module.exports = __webpack_public_path__ + "img/thermometer-warm.b9a6db26.svg";